import { Moment } from 'moment';

export const rdsDateOperations = ['>', '>=', '=', '!=', '<', '<='] as const;
export type RdsDateOperation = typeof rdsDateOperations[number];

export const rdsDateOperationLabels: Record<RdsDateOperation, string> = {
  '>': 'Greater than',
  '>=': 'Greater than or Equal to',
  '=': 'Equal to',
  '!=': 'Not Equal to',
  '<': 'Less than',
  '<=': 'Less than or Equal to',
} as const;

export function invertDateOperation(operation: RdsDateOperation): RdsDateOperation {
  switch (operation) {
    case '>':
      return '<';
    case '>=':
      return '<=';
    case '=':
      return '!=';
    case '!=':
      return '=';
    case '<':
      return '>';
    case '<=':
      return '>=';
  }
}

export class RdsDateOperationOption {
  constructor(public label: string, public type: RdsDateOperation) {}
}

export const RDS_DATE_OPERATION_OPTIONS: ReadonlyArray<RdsDateOperationOption> = Object.freeze(
  rdsDateOperations.map((operation) => new RdsDateOperationOption(rdsDateOperationLabels[operation], operation))
);

export class RdsDateFilter {
  constructor(public value: Moment, public operation: RdsDateOperationOption) {}
}

/** @returns A date string formatted as YYYY-MM-DD given a `RdsDateFilter` */
export function getRdsDateFilterIso(filter: RdsDateFilter): string {
  return getRdsMomentIso(filter?.value);
}

/** @returns A date string formatted as YYYY-MM-DD given a moment date */
export function getRdsMomentIso(date: Moment): string {
  return date?.format('YYYY-MM-DD');
}

export function instanceOfRdsDateFilter(obj: any): obj is RdsDateFilter {
  return !!obj && 'value' in obj && 'operation' in obj && rdsDateOperations.includes(obj.operation);
}
